import {
    type GetAllAnnouncementsResponseType,
    type GetAllAnnouncementsRequestType
} from "./type";
import {
    request
} from "../request";

const GetAllAnnouncements = async (params: GetAllAnnouncementsRequestType): Promise<GetAllAnnouncementsResponseType> => {
    return await request<GetAllAnnouncementsResponseType>("/announcement/getAllAnnouncements", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetAllAnnouncements;
